var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"modal-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-backdrop in at-front"},[_c('div',{staticClass:"loader"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }